// @flow

import type { UiPopup } from 'redux/type/uiPopup'

import React from 'react'
import styles from './AlertPopup.scss'

export default class extends React.PureComponent<{
  uiPopup: UiPopup
}> {
  render () {
    const {
      popupType,
      title,
      dangerousHtml,
      message,
      ok = '确定',
      cancel = '取消',
      onOk,
      onCancel
    } = this.props.uiPopup
    return (
      <div className={styles.this}>
        <div className={styles.main}>
          <div className={styles.title}>{title}</div>
          <div
            className={styles.content}
            style={{ marginTop: !title && '30px' }}
          >
            {dangerousHtml ? (
              <div dangerouslySetInnerHTML={{ __html: dangerousHtml }} />
            ) : (
              message
            )}
          </div>
          <div
            className={styles.button}
            style={{ padding: '10px 0', fontSize: 18 }}
          >
            {popupType === 'confirm' && (
              <div onClick={onCancel} className={styles.cancel}>
                {cancel}
                <i />
              </div>
            )}
            <div onClick={onOk}>{ok}</div>
          </div>
        </div>
        <div className={styles.shade} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frame/ui/popup/AlertPopup.js